{
  "about.blocks": "Leurennow koswys",
  "account.add_or_remove_from_list": "Keworra po Dilea a rolyow",
  "account.badges.bot": "Bot",
  "account.badges.group": "Bagas",
  "account.block": "Lettya @{name}",
  "account.block_domain": "Lettya gorfarth {domain}",
  "account.blocked": "Lettys",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.disable_notifications": "Hedhi ow gwarnya pan wra @{name} postya",
  "account.edit_profile": "Golegi profil",
  "account.enable_notifications": "Gwra ow gwarnya pan wra @{name} postya",
  "account.endorse": "Diskwedhes yn profil",
  "account.follow": "Holya",
  "account.followers": "Holyoryon",
  "account.followers.empty": "Ny wra nagonan holya'n devnydhyer ma hwath.",
  "account.follows.empty": "Ny wra'n devnydhyer ma holya nagonan hwath.",
  "account.hide_reblogs": "Kudha kenerthow a @{name}",
  "account.link_verified_on": "Perghenogeth an kolm ma a veu checkys dhe {date}",
  "account.locked_info": "Studh privetter an akont ma yw alhwedhys. An perghen a wra dasweles dre leuv piw a yll aga holya.",
  "account.media": "Myski",
  "account.mention": "Meneges @{name}",
  "account.mute": "Tawhe @{name}",
  "account.muted": "Tawhes",
  "account.posts": "Postow",
  "account.report": "Reportya @{name}",
  "account.share": "Kevrenna profil @{name}",
  "account.show_reblogs": "Diskwedhes kenerthow a @{name}",
  "account.unblock": "Anlettya @{name}",
  "account.unblock_domain": "Anlettya gorfarth {domain}",
  "account.unendorse": "Na wra diskwedhes yn profil",
  "account.unfollow": "Anholya",
  "account.unmute": "Antawhe @{name}",
  "account_note.placeholder": "Klyckya dhe geworra noten",
  "alert.rate_limited.message": "Assayewgh arta mar pleg wosa {retry_time, time, medium}.",
  "alert.rate_limited.title": "Kevradh finwethys",
  "alert.unexpected.message": "Gwall anwaytyadow re dharva.",
  "alert.unexpected.title": "Oups!",
  "announcement.announcement": "Deklaryans",
  "boost_modal.combo": "Hwi a yll gwaska {combo} dhe woheles hemma an nessa tro",
  "bundle_column_error.retry": "Assayewgh arta",
  "bundle_modal_error.close": "Degea",
  "bundle_modal_error.retry": "Assayewgh arta",
  "column.blocks": "Devnydhyoryon lettys",
  "column.bookmarks": "Folennosow",
  "column.community": "Amserlin leel",
  "column.directory": "Peuri profilys",
  "column.domain_blocks": "Gorfarthow lettys",
  "column.follow_requests": "Govynnow holya",
  "column.home": "Tre",
  "column.lists": "Rolyow",
  "column.mutes": "Devnydhyoryon tawhes",
  "column.notifications": "Gwarnyansow",
  "column.pins": "Postow fastys",
  "column.public": "Amserlin geffrysys",
  "column_back_button.label": "War-gamm",
  "column_header.hide_settings": "Kudha dewisyow",
  "column_header.moveLeft_settings": "Removya koloven dhe-gledh",
  "column_header.moveRight_settings": "Removya koloven dhe-dhyghow",
  "column_header.pin": "Fastya",
  "column_header.show_settings": "Diskwedhes dewisyow",
  "column_header.unpin": "Anfastya",
  "community.column_settings.local_only": "Leel hepken",
  "community.column_settings.media_only": "Myski hepken",
  "community.column_settings.remote_only": "A-bell hepken",
  "compose_form.direct_message_warning_learn_more": "Dyski moy",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Nyns yw agas akont {locked}. Piwpynag a yll agas holya dhe weles agas postow holyoryon-hepken.",
  "compose_form.lock_disclaimer.lock": "Alhwedhys",
  "compose_form.placeholder": "Pyth eus yn agas brys?",
  "compose_form.poll.duration": "Duryans sondyans",
  "compose_form.poll.switch_to_multiple": "Chanjya sondyans dhe asa lies dewis",
  "compose_form.poll.switch_to_single": "Chanjya sondyans dhe asa unn dewis hepken",
  "compose_form.spoiler.marked": "Dilea gwarnyans dalgh",
  "compose_form.spoiler.unmarked": "Keworra gwarnyans dalgh",
  "confirmation_modal.cancel": "Hedhi",
  "confirmations.block.confirm": "Lettya",
  "confirmations.delete.confirm": "Dilea",
  "confirmations.delete.message": "Owgh hwi sur a vynnes dilea'n post ma?",
  "confirmations.delete_list.confirm": "Dilea",
  "confirmations.delete_list.message": "Owgh hwi sur a vynnes dilea'n rol ma yn fast?",
  "confirmations.logout.confirm": "Digelmi",
  "confirmations.logout.message": "Owgh hwi sur a vynnes digelmi?",
  "confirmations.mute.confirm": "Tawhe",
  "confirmations.redraft.confirm": "Dilea & daskynskrifa",
  "confirmations.unfollow.confirm": "Anholya",
  "conversation.delete": "Dilea kesklapp",
  "conversation.mark_as_read": "Merkya vel redys",
  "conversation.open": "Gweles kesklapp",
  "conversation.with": "Gans {names}",
  "directory.federated": "A geffrysvys godhvedhys",
  "directory.local": "A {domain} hepken",
  "directory.new_arrivals": "Devedhyansow nowydh",
  "directory.recently_active": "Bew a-gynsow",
  "embed.instructions": "Stagewgh an post ma a-berth yn agas gwiasva ow tasskrifa'n kod a-wòles.",
  "embed.preview": "Ottomma fatel hevel:",
  "emoji_button.activity": "Gwrians",
  "emoji_button.custom": "A-vusur",
  "emoji_button.flags": "Baneryow",
  "emoji_button.food": "Bòs & Diwes",
  "emoji_button.label": "Keworra emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Emojos vyth!! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Taklennow",
  "emoji_button.people": "Tus",
  "emoji_button.recent": "Usys yn fenowgh",
  "emoji_button.search": "Hwilas...",
  "emoji_button.search_results": "Sewyansow hwilas",
  "emoji_button.symbols": "Nosow",
  "emoji_button.travel": "Vyajya & Tylleryow",
  "empty_column.account_suspended": "Akont difennys",
  "empty_column.account_timeline": "Postow vyth omma!",
  "empty_column.account_unavailable": "Profil ankavadow",
  "empty_column.blocks": "Ny wrussowgh lettya devnydhyoryon vyth hwath.",
  "empty_column.bookmarked_statuses": "Nyns eus dhywgh postow gans folennos hwath. Pan wrewgh gorra onan, ev a wra omdhiskwedhes omma.",
  "empty_column.community": "An amserlin leel yw gwag. Skrifewgh neppytn yn poblek dh'y lonchya!",
  "empty_column.domain_blocks": "Nyns eus gorfarthow lettys hwath.",
  "empty_column.follow_requests": "Nyns eus dhywgh govynnow holya hwath. Pan wrewgh degemeres onan, ev a wra omdhiskwedhes omma.",
  "empty_column.hashtag": "Nyns eus travyth y'n bòlnos ma hwath.",
  "empty_column.home": "Agas amserlin dre yw gwag! Holyewgh moy a dus dh'y lenwel. {suggestions}",
  "empty_column.list": "Nyns eus travyth y'n rol ma hwath. Pan wra eseli an rol ma dyllo postow nowydh, i a wra omdhiskwedhes omma.",
  "empty_column.mutes": "Ny wrussowgh tawhe devnydhyoryon vyth hwath.",
  "empty_column.notifications": "Nyns eus dhywgh gwarnyansow hwath. Pan wra tus erel ynterweythresa genowgh, hwi a'n gwel omma.",
  "empty_column.public": "Nyns eus travyth omma! Skrifewgh neppyth yn poblek, po holyewgh tus a leurennow erel dre leuv dh'y lenwel",
  "error.unexpected_crash.explanation": "Awos gwall yn agan kod po kudyn kesplegadewder an beurell, ny yllir displetya'n folen ma yn ewn.",
  "error.unexpected_crash.explanation_addons": "Ny yllir displetya'n folen ma yn ewn. Dres lycklod, skila'n gwall ma yw keworrans an beurell po daffar treylya awtomatek.",
  "error.unexpected_crash.next_steps": "Assayewgh daskarga'n folen. Mar ny'gas gweres, martesen hwi a yll hwath usya Mastodon dre beurell aral po app teythyek.",
  "error.unexpected_crash.next_steps_addons": "Assayewgh aga disweythresa ha daskarga'n folen. Mar ny'gas gweres, martesen hwi a yll hwath usya Mastodon dre beurell aral po app teythyek.",
  "errors.unexpected_crash.copy_stacktrace": "Dasskrifa daslergh dhe'n astel glypp",
  "errors.unexpected_crash.report_issue": "Reportya kudyn",
  "follow_request.authorize": "Ri kummyas",
  "follow_request.reject": "Denagha",
  "follow_requests.unlocked_explanation": "Kyn na vo agas akont alhwedhys, an meni {domain} a wrug tybi y fia da genowgh dasweles govynnow holya a'n akontys ma dre leuv.",
  "generic.saved": "Gwithys",
  "getting_started.heading": "Dhe dhalleth",
  "hashtag.column_header.tag_mode.all": "ha(g) {additional}",
  "hashtag.column_header.tag_mode.any": "po {additional}",
  "hashtag.column_header.tag_mode.none": "heb {additional}",
  "hashtag.column_settings.select.no_options_message": "Ny veu kevys profyansow vyth",
  "hashtag.column_settings.select.placeholder": "Gorrewgh bòlnosow...",
  "hashtag.column_settings.tag_mode.all": "Oll a'n re ma",
  "hashtag.column_settings.tag_mode.any": "Pynag a'n re ma",
  "hashtag.column_settings.tag_mode.none": "Travyth a'n re ma",
  "hashtag.column_settings.tag_toggle": "Yssynsi taggys ynwedhek rag an goloven ma",
  "home.column_settings.show_reblogs": "Diskwedhes kenerthow",
  "home.column_settings.show_replies": "Diskwedhes gorthebow",
  "home.hide_announcements": "Kudha deklaryansow",
  "home.show_announcements": "Diskwedhes deklaryansow",
  "intervals.full.days": "{number, plural, one {# jydh} other {# a jydhyow}}",
  "intervals.full.hours": "{number, plural, one {# our} other {# our}}",
  "intervals.full.minutes": "{number, plural, one {# vynysen} other {# a vynysennow}}",
  "keyboard_shortcuts.back": "Omremovya war-gamm",
  "keyboard_shortcuts.blocked": "Ygeri rol a dhevnydhyoryon lettys",
  "keyboard_shortcuts.boost": "Kenertha post",
  "keyboard_shortcuts.column": "Fogella koloven",
  "keyboard_shortcuts.compose": "Fogella tekstva gomposya",
  "keyboard_shortcuts.description": "Deskrifans",
  "keyboard_shortcuts.down": "Movya war-nans y'n rol",
  "keyboard_shortcuts.enter": "Ygeri post",
  "keyboard_shortcuts.federated": "Ygeri amserlin geffrysys",
  "keyboard_shortcuts.heading": "Kottfordhow an vysowek",
  "keyboard_shortcuts.home": "Ygeri amserlin dre",
  "keyboard_shortcuts.hotkey": "Buanell",
  "keyboard_shortcuts.legend": "Displetya'n weresva ma",
  "keyboard_shortcuts.local": "Ygeri amserlin leel",
  "keyboard_shortcuts.mention": "Meneges awtour",
  "keyboard_shortcuts.muted": "Ygeri rol a dhevnydhyoryon tawhes",
  "keyboard_shortcuts.my_profile": "Ygeri agas profil",
  "keyboard_shortcuts.notifications": "Ygeri koloven gwarnyansow",
  "keyboard_shortcuts.open_media": "Ygeri myski",
  "keyboard_shortcuts.pinned": "Ygeri rol a bostow fastys",
  "keyboard_shortcuts.profile": "Ygeri profil an awtour",
  "keyboard_shortcuts.reply": "Gorthebi orth post",
  "keyboard_shortcuts.requests": "Ygeri rol govynnow holya",
  "keyboard_shortcuts.search": "Fogella'n barr hwilas",
  "keyboard_shortcuts.spoilers": "Diskwedhes/kudha'n skrifva GD",
  "keyboard_shortcuts.start": "Ygeri koloven \"dhe dhalleth\"",
  "keyboard_shortcuts.toggle_hidden": "Diskwedhes/kudha tekst yn-dann GD",
  "keyboard_shortcuts.toggle_sensitivity": "Diskwedhes/kudha myski",
  "keyboard_shortcuts.toot": "Dalleth post nowydh",
  "keyboard_shortcuts.unfocus": "Anfogella tekstva gomposya/hwilas",
  "keyboard_shortcuts.up": "Movya war-vann y'n rol",
  "lightbox.close": "Degea",
  "lightbox.next": "Nessa",
  "lightbox.previous": "Kynsa",
  "lists.delete": "Dilea rol",
  "lists.edit": "Golegi rol",
  "lists.replies_policy.followed": "Py devnydhyer holys pynag",
  "lists.replies_policy.list": "Eseli an rol",
  "lists.replies_policy.none": "Nagonan",
  "load_pending": "{count, plural, one {# daklennowydh} other {# a daklennow nowydh}}",
  "navigation_bar.blocks": "Devnydhyoryon lettys",
  "navigation_bar.bookmarks": "Folennosow",
  "navigation_bar.domain_blocks": "Gorfarthow lettys",
  "navigation_bar.filters": "Geryow tawhes",
  "navigation_bar.follow_requests": "Govynnow holya",
  "navigation_bar.follows_and_followers": "Holyansow ha holyoryon",
  "navigation_bar.lists": "Rolyow",
  "navigation_bar.logout": "Digelmi",
  "navigation_bar.mutes": "Devnydhyoryon tawhes",
  "navigation_bar.preferences": "Erviransow",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} a wrug agas holya",
  "notification.follow_request": "{name} a bysis agas holya",
  "notification.own_poll": "Agas sondyans a worfennas",
  "notification.reblog": "{name} a generthas agas post",
  "notification.status": "{name} a wrug nowydh postya",
  "notifications.clear": "Dilea gwarnyansow",
  "notifications.clear_confirmation": "Owgh hwi sur a vynnes dilea agas gwarnyansow oll yn fast?",
  "notifications.column_settings.alert": "Gwarnyansow pennskrin",
  "notifications.column_settings.follow": "Holyoryon nowydh:",
  "notifications.column_settings.follow_request": "Govynnow holya nowydh:",
  "notifications.column_settings.mention": "Menegow:",
  "notifications.column_settings.poll": "Sewyansow an sondyans:",
  "notifications.column_settings.push": "Gwarnyansow omherdhus",
  "notifications.column_settings.reblog": "Kenerthow:",
  "notifications.column_settings.show": "Diskwedhes yn koloven",
  "notifications.column_settings.sound": "Seni son",
  "notifications.column_settings.status": "Postow nowydh:",
  "notifications.filter.all": "Oll",
  "notifications.filter.boosts": "Kenerthow",
  "notifications.filter.follows": "Holyansow",
  "notifications.filter.mentions": "Menegow",
  "notifications.filter.polls": "Sewyansow an sondyans",
  "notifications.filter.statuses": "Nowedhyansow a dus a holyewgh",
  "notifications.grant_permission": "Ri kummyas.",
  "notifications.group": "{count} a warnyansow",
  "notifications.mark_as_read": "Merkya pub gwarnyans vel redys",
  "notifications.permission_denied": "Nyns yw gwarnyansow pennskrin kavadow awos govyn kummyas an beurell denaghys",
  "notifications.permission_denied_alert": "Ny yllir gweythresa gwarnyansow pennskrin, awos kummyas an beurell dhe vos denaghys kyns",
  "notifications.permission_required": "Nyns yw gwarnyansow pennskrin kavadow awos na wrug ri an kummyas res.",
  "notifications_permission_banner.enable": "Gweythresa gwarnyansow pennskrin",
  "notifications_permission_banner.how_to_control": "Dhe dhegemeres gwarnyansow pan na vo Mastodon ygerys, gwrewgh gweythresa gwarnyansow pennskrin. Hwi a yll dyghtya py eghennow a ynterweythresow a wra gwarnyansow pennskrin der an boton {icon} a-wartha, pan vons gweythresys.",
  "notifications_permission_banner.title": "Na wrewgh kelli travyth",
  "picture_in_picture.restore": "Daskor e",
  "poll.closed": "Deges",
  "poll.refresh": "Daskarga",
  "poll.total_people": "{count, plural, one {# den} other {# a dus}}",
  "poll.total_votes": "{count, plural, one {# raglev} other {# raglev}}",
  "poll.vote": "Ragleva",
  "poll.voted": "Hwi a wrug ragleva'n gorthyp ma",
  "poll_button.add_poll": "Keworra sondyans",
  "poll_button.remove_poll": "Dilea sondyans",
  "privacy.change": "Chanjya privetter an post",
  "privacy.public.short": "Poblek",
  "refresh": "Daskarga",
  "relative_time.days": "{number}d",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "lemmyn",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}e",
  "relative_time.today": "hedhyw",
  "reply_indicator.cancel": "Hedhi",
  "report.forward": "Dasvovya dhe {target}",
  "report.forward_hint": "Yma'n akont ma a leuren aral. Dannvon dasskrif dihanow an derivas ena ynwedh?",
  "report.placeholder": "Kampòllow ynwedhek",
  "report.submit": "Dannvon",
  "report.target": "Ow reportya {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "Hwilas",
  "search_results.hashtags": "Bòlnosow",
  "search_results.statuses": "Postow",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "Ygeri ynterfas koswa rag @{name}",
  "status.admin_status": "Ygeri an post ma y'n ynterfas koswa",
  "status.block": "Lettya @{name}",
  "status.bookmark": "Folennos",
  "status.cancel_reblog_private": "Ankenertha",
  "status.cannot_reblog": "Ny yllir kenertha'n post ma",
  "status.copy": "Dasskrifa kolm dhe'n post",
  "status.delete": "Dilea",
  "status.detailed_status": "Gwel kesklapp a-vanyl",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "Karga moy",
  "status.media_hidden": "Myski kudhys",
  "status.mention": "Meneges @{name}",
  "status.more": "Moy",
  "status.mute": "Tawhe @{name}",
  "status.mute_conversation": "Tawhe kesklapp",
  "status.open": "Efani'n post ma",
  "status.pin": "Fastya yn profil",
  "status.read_more": "Redya moy",
  "status.reblog": "Kenertha",
  "status.reblogged_by": "{name} a generthas",
  "status.reblogs.empty": "Ny wrug nagonan kenertha'n post ma hwath. Pan wra, hynn a wra omdhiskwedhes omma.",
  "status.redraft": "Dilea ha daskynskrifa",
  "status.remove_bookmark": "Dilea folennos",
  "status.reply": "Gorthebi",
  "status.replyAll": "Gorthebi orth neusen",
  "status.report": "Reportya @{name}",
  "status.sensitive_warning": "Dalgh tender",
  "status.share": "Kevrenna",
  "status.show_less_all": "Diskwedhes le rag puptra",
  "status.show_more_all": "Diskwedhes moy rag puptra",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.unmute_conversation": "Antawhe kesklapp",
  "status.unpin": "Anfastya a brofil",
  "tabs_bar.home": "Tre",
  "tabs_bar.notifications": "Gwarnyansow",
  "time_remaining.days": "{number, plural, one {# jydh} other {# a jydhyow}} gesys",
  "time_remaining.hours": "{number, plural, one {# our} other {# our}} gesys",
  "time_remaining.minutes": "{number, plural, one {# vynysen} other {# a vynysennow}} gesys",
  "time_remaining.moments": "Polsyow gesys",
  "time_remaining.seconds": "{number, plural, one {# eylen} other {# eylen}} gesys",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Tuedhegus lemmyn",
  "ui.beforeunload": "Agas kysnkrif a vydh kellys mar kwrewgh diberth a Mastodon.",
  "units.short.billion": "{count}Mek",
  "units.short.million": "{count}Mas",
  "units.short.thousand": "{count}M",
  "upload_area.title": "Tenna & gasa dhe ughkarga",
  "upload_button.label": "Keworra skeusennow, gwydhyow po sonadow",
  "upload_error.limit": "Finweth ughkarga a veu gorfassys.",
  "upload_error.poll": "Nyns yw gesys ughkarga restrennow gans sondyansow.",
  "upload_form.edit": "Golegi",
  "upload_progress.label": "Owth ughkarga...",
  "video.close": "Degea gwydhyow",
  "video.download": "Iskarga restren",
  "video.exit_fullscreen": "Diberth a skrin leun",
  "video.expand": "Efani gwydhyow",
  "video.fullscreen": "Skrin leun",
  "video.hide": "Kudha gwydhyow",
  "video.pause": "Powes",
  "video.play": "Seni"
}
